import { appConfig } from "./tenantConfig";

const isTrue = (value) =>
  String(value || "")
    .trim()
    .toLowerCase() === "true";

export const isPublicVerificationPortalEnabled = () =>
  isTrue(process.env.REACT_APP_ENABLE_PUBLIC_VERIFICATION_PORTAL);

export const isWasmQrScannerEnabled = () =>
  isTrue(process.env.REACT_APP_ENABLE_WASM_QR_SCANNER);

export const isLanguageSwitchEnabled = () =>
  isTrue(process.env.REACT_APP_ENABLE_LANGUAGE_SWITCH);

export const isTelemetryEnabled = () =>
  isTrue(process.env.REACT_APP_OTEL_ENABLED);

export const isOtelAlertTelemetryEnabled = () => isTelemetryEnabled();

export const isSunbirdValidationEnabled = () => {
  const raw = process.env.REACT_APP_ENABLE_SUNBIRD_VALIDATION;
  return raw === undefined || raw === "" || isTrue(raw);
};

export const isOcrFlowEnabled = () => {
  const raw = process.env.REACT_APP_ENABLE_OCR_FLOW;
  return raw === undefined || raw === "" || isTrue(raw);
};

export const isPublicDualDocumentPreviewEnabled = () => {
  const raw = process.env.REACT_APP_ENABLE_PUBLIC_DUAL_DOCUMENT_PREVIEW;
  if (raw === undefined || raw === "") {
    return Boolean(appConfig.publicDualDocumentPreview);
  }
  return isTrue(raw);
};

export const isSentryEnabled = () =>
  isTrue(process.env.REACT_APP_SENTRY_ENABLED) &&
  Boolean(String(process.env.REACT_APP_SENTRY_DSN || "").trim());

export const isPublicVerificationPortalRoute = (
  pathname = typeof window !== "undefined" ? window.location.pathname : "",
) => {
  if (!isPublicVerificationPortalEnabled()) return false;
  return pathname === "/" || pathname === "/verification-result";
};
